var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5005 10V2.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9927 6.25L4.0083 13.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12556 11.375C3.0403 10.9217 2.99844 10.4613 3.00057 10C2.99958 8.4489 3.48003 6.93573 4.37562 5.6693C5.27122 4.40288 6.53779 3.44564 8.00057 2.92969V8.55469L3.12556 11.375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5005 2.5C11.8147 2.50015 13.1058 2.84561 14.2444 3.50179C15.3831 4.15797 16.3293 5.10183 16.9884 6.23881C17.6474 7.3758 17.9961 8.66601 17.9996 9.98019C18.0031 11.2944 17.6612 12.5864 17.0081 13.7269C16.3551 14.8673 15.4139 15.8162 14.2787 16.4783C13.1435 17.1405 11.8543 17.4928 10.5401 17.4999C9.22594 17.507 7.93297 17.1686 6.79072 16.5187C5.64848 15.8688 4.69705 14.9302 4.03174 13.7969",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.c093a209071142b6a1d64117fd611bf3.svg";
export { ForwardRef as ReactComponent };